<app-banner-app [retroSelected]="true"></app-banner-app>
<br><br><br><br><br><br>

<div class="container">
    <br><br>
    <div class="row">
        <div class="col">
            <div class="container" style="text-align: center;">
                <span class="tipografiaCard">Antes de firmar el contrato</span><br>
                <span class="textoDetalleTipografia">
                    <br>
                    Asegúrate de leer detenidamente y verificar que la información sea correcta
                </span><br><br>
            </div>

            <div class="container" style="text-align: center;">
                <div class="card">
                    <h5 class="card-header textoCard"
                        style="height: 60px;background-color: white; margin-top: 22px; text-align: left;">
                        CONTRATO DE ARRENDAMIENTO
                    </h5>
                    <div class="card-body">

                        <div class="card">
                            <div class="card-body">
                                <textarea class="textoParrafo" rows="10" cols="135" pInputTextarea
                                    style="border-color: transparent;">
PARÁGRAFO PRIMERO: Las reclamaciones que tengan que ver con la óptima prestación o facturación de los servicios públicos anotados, serán tramitadas directamente por EL ARRENDATARIO ante las respectivas empresas prestadoras del servicio. Cualquier otro servicio adicional o suntuario al que pretenda acceder el ARRENDATARIO, deberá ser previamente autorizado por el ARRENDADOR. 
PARÁGRAFO SEGUNDO: Si el ARRENDATARIO no paga oportunamente los servicios públicos antes señalados, este hecho se tendrá como incumplimiento del contrato, pudiendo el ARRENDADOR darlo por terminado unilateralmente sin necesidad de los requerimientos privados y judiciales previstos en la Ley (artículos 1594 y 2007 del Código Civil). 
PARÁGRAFO TERCERO: En cualquier caso, el incumplimiento de los pagos de servicios públicos a cargo del ARRENDATARIO, EL ARRENDADOR queda facultado para exigir de aquel el pago oportuno de los intereses de mora, sanciones, y los gastos que demande su re conexión, en caso de la suspensión o retiro. SEXTA.- CUOTAS DE ADMINISTRACIÓN. Si el inmueble objeto de este contrato se encuentra sometido al régimen de propiedad horizontal y el valor de la cuota de administración no hace parte del canon de arrendamiento, el ARRENDATARIO se obliga a pagar directamente al ARRENDADOR el valor mensual que por concepto de cuota de administración se encuentre a la fecha de iniciación del presente contrato aprobada por la asamblea de copropietarios, dentro de los cinco (5) primeros días del respectivo mes
Información que se relacione con este contrato, o que de terminación. El ARRENDATARIO declara que la información es irrevocable a el ARRENDADOR o quien este señale, reportar a las centrales de información financiera, tanto se hubiere, de nuestras obligaciones crediticias o deberes, las autoridades tributarias, aduaneras o judiciales la información y acatamiento de nuestros deberes constitucionales y legales.

DECIMA NOVENA-FIRMAS DE LAS PARTES: Es voluntad el presente contrato será firma electrónica; por tanto técnicas de identificación personal o autenticación electrónica tienen plena validez jurídica al 
                              </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <span style="padding-left: 15px;" class="textoTerminos">
                ¿Leíste el contrato de arrendamiento y 
                <span class="textoAcepta">aceptas los términos?</span>
            </span>
            <br><br>
            <div style="width: 366px;padding-left: 10px;">
                <div class="container">
                    <div class="row justify-content-start">
                        <div class="col-4">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="rbtOption" checked
                                    value="Si">
                                <label class="form-check-label textoTerminos" for="rbtSi">
                                    Si
                                </label>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="rbtOption" value="No">
                                <label class="form-check-label textoTerminos" for="rbtNo">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br><br>

            <div style="width: 30%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit">Firmar</button>
            </div>
        </div>
    </div>

</div>

<br><br><br>
<app-footer-app></app-footer-app>